export default "__VITE_ASSET__CNvByFBD__"